export default __webpack_public_path__ + "static/media/personaje-Banner-02.2acb4637.png";